import React from 'react'
import { TabDiv } from './TabStyled'
import { TabProps } from './interfaces'

const Tab = ({
  name,
  active,
  handleActive,
  activeColor,
  inactiveColor,
}: TabProps) => {
  return (
    <TabDiv
      onClick={() => handleActive(name)}
      active={active === name}
      activeColor={activeColor}
      inactiveColor={inactiveColor}
    >
      <div className='inner' />
      <p>{name.toUpperCase()}</p>
    </TabDiv>
  )
}

export default Tab
